module.exports = __webpack_public_path__ + "img/blfgc01_center_001.e46a340b.png";